/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, post } from './client.js'
// ─── Ajustes de preço com aprovação (#274 + #284) ────────────────────────────

export type AdjustmentType = 'price_override' | 'discount_percent' | 'discount_amount' | 'none'
export type AdjustmentInput =
  | {
      target: 'item'
      order_item_id: string
      type: AdjustmentType
      value?: number
      reason?: string
    }
  | {
      target: 'order'
      type: Exclude<AdjustmentType, 'price_override'>
      value?: number
      reason?: string
    }

export type AdjustmentRequestDto = {
  id: string
  order_id: string
  order_item_id: string | null
  target: 'item' | 'order'
  type: AdjustmentType
  value: number | null
  reason: string | null
  status: 'pending' | 'approved' | 'rejected' | 'cancelled'
  current_type: string | null
  current_value: number | null
  current_unit_price_cents: number | null
  proposed_unit_price_cents: number | null
  order_total_at_request_cents: number
  requested_by: string
  requested_role: string
  requested_by_name: string | null
  requested_at: number
  decided_by: string | null
  decided_role: string | null
  decided_by_name: string | null
  decided_at: number | null
  decision_note: string | null
  adjustment_id: string | null
  /** auto-aprovado dentro do limite do garçom (0056) */
  auto_approved?: boolean
  limit_type?: 'percent' | 'amount' | null
  limit_value?: number | null
  table_number: number | null
  table_label: string | null
}

export type AppliedAdjustmentDto = {
  id: string
  order_id: string
  order_item_id: string | null
  target: 'item' | 'order'
  action: 'set' | 'remove' | 'auto_clear'
  previous_type: string | null
  previous_value: number | null
  new_type: string | null
  new_value: number | null
  previous_unit_price_cents: number | null
  new_unit_price_cents: number | null
  order_total_before_cents: number
  order_total_after_cents: number
  reason: string | null
  actor_id: string
  actor_role: string
  actor_name: string | null
  created_at: number
  request: AdjustmentRequestDto | null
}

export const adjustmentsApi = {
  /** Gerente/Dono: aplica direto. */
  apply: (orderId: string, body: AdjustmentInput) =>
    post<unknown>(`/orders/${orderId}/adjustments`, body),
  /** Garçom: pede (aplica só após aprovação). */
  request: (orderId: string, body: AdjustmentInput) =>
    post<AdjustmentRequestDto>(`/orders/${orderId}/adjustment-requests`, body),
  inbox: (status?: AdjustmentRequestDto['status']) =>
    get<AdjustmentRequestDto[]>(`/admin/adjustment-requests${status ? `?status=${status}` : ''}`),
  mine: () => get<AdjustmentRequestDto[]>('/admin/adjustment-requests/mine'),
  audit: () =>
    get<{ applied: AppliedAdjustmentDto[]; requests: AdjustmentRequestDto[] }>(
      '/admin/adjustment-requests/audit',
    ),
  approve: (id: string, note?: string) =>
    post<unknown>(`/admin/adjustment-requests/${id}/approve`, note ? { note } : {}),
  reject: (id: string, note: string) =>
    post<unknown>(`/admin/adjustment-requests/${id}/reject`, { note }),
  cancel: (id: string) => post<unknown>(`/admin/adjustment-requests/${id}/cancel`, {}),
}
